import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgEngagementOnImpressionsPerPostConfig: KpiType<
    typeof DefaultLoader,
    typeof KPIDefault
> = {
    name: 'kpi.twitter.avg_engagement_on_impressions_per_post',
    id: 'average_engagement_on_impressions_per_post',
    orientation: ORIENTATION_VERTICAL,
    icon: {
        name: 'engagement',
        style: colors.green
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    tooltip: 'kpi.twitter.tooltip_avg_engagement_on_impressions_per_post',
    size: SIZE_33,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
